
import SuluView from '~/views/sulu-view';
import seo from '~/mixins/seo';

export default {
  name: 'dynamic-route',
  layout: 'index',
  transition: 'fade',
  components: {
    SuluView,
  },
  mixins: [seo],
  async asyncData ({ store, params, error, redirect }) {
    const path = params.pathMatch;
    const content = await store.dispatch('getData', `/${path}`)
      .catch(e => {
        if (e.status === 301) redirect(e.url);
        // eslint-disable-next-line no-console
        else console.error(e.status, e.message);
        error(e);
      });
    return {content};
  },
  data () {
    return {
      content: {},
    };
  },
};
